export {
  canUseLoadedValues,
  readQrConfig,
  readStockConfig,
  type QrLabelConfig,
  type ValueStockConfig,
  type ValueStockOnVoid,
} from "@/shared/lib/value-stock-field";

const RANGE_TAIL = /^(.*?)(\d+)$/;

export const STOCK_RANGE_LIMIT = 50_000;
export const STOCK_FILE_MAX_BYTES = 2 * 1024 * 1024;
export const STOCK_LOAD_CHUNK = 2_000;

/** Split a pasted or uploaded blob into values, de-duplicated case-insensitively. */
export function parseStockValues(raw: string): string[] {
  const seen = new Set<string>();
  const values: string[] = [];
  for (const part of raw.split(/[\n,]+/)) {
    const value = part.trim();
    if (!value) continue;
    const key = value.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    values.push(value);
  }
  return values;
}

/**
 * How many values a range covers, or why it cannot be read.
 *
 * Mirrors the server's expansion so the count can be shown before the request
 * is sent rather than after it comes back.
 */
export function describeStockRange(
  start: string,
  end: string,
  limit = STOCK_RANGE_LIMIT,
): { count: number } | { error: "prefix" | "order" | "limit" | "shape" } {
  const left = start.trim();
  const right = end.trim();
  const matchLeft = left.match(RANGE_TAIL);
  const matchRight = right.match(RANGE_TAIL);
  if (!matchLeft || !matchRight) return { error: "shape" };
  if (matchLeft[1] !== matchRight[1]) return { error: "prefix" };
  const first = Number(matchLeft[2]);
  const last = Number(matchRight[2]);
  if (last < first) return { error: "order" };
  const count = last - first + 1;
  if (count > limit) return { error: "limit" };
  return { count };
}
